// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.texts_zone_content_cards {
  background-color: #2E2632;
  padding: 0.5rem 0.6rem;
  width: 90%;
  margin: 0.5rem auto;
  border-radius: 0.8rem;
  border: none;
}
.texts_zone_content_cards_header {
  width: 100%;
  display: flex;
  align-items: center;
}
.texts_zone_content_cards_header .ref {
  font-size: 0.8rem;
  font-weight: 600;
  color: #898989;
  width: 20%;
}
.texts_zone_content_cards_header .options {
  width: 80%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.5rem;
  position: relative;
}
.texts_zone_content_cards_header .options select,
.texts_zone_content_cards_header .options input {
  width: 23%;
  height: 1.2rem;
  font-size: 0.7rem;
  border-radius: 0.8rem;
  text-align: center;
  outline: none;
  border: none;
}
.texts_zone_content_cards_header .options input[type=number] {
  width: 16%;
}
.texts_zone_content_cards_header .options #color {
  width: 1.2rem;
  height: 1.2rem;
  border-radius: 50%;
}
.texts_zone_content_cards_header .options .fontStyle {
  color: orangered;
  width: 1.2rem;
  height: 1.2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  cursor: pointer;
  font-weight: 600;
  color: #898989;
  background-color: #1C1620;
  position: relative;
  top: 0;
}
.texts_zone_content_cards_header .options .hidden-color-input {
  position: absolute;
  bottom: -0.5rem;
  left: 0;
  opacity: 0;
  width: 0;
  height: 0;
  pointer-events: none;
}
.texts_zone_content_cards_header .options .stroke_section {
  width: 10rem;
  height: 14rem;
  background-color: #1C1620;
  border: 1px solid #d2d0d0;
  border-radius: 0.3rem;
  position: absolute;
  left: -3rem;
  bottom: -14.1rem;
  z-index: 1000;
}
.texts_zone_content_cards_header .options .stroke_section .show_hide_stroke {
  width: 100%;
  font-size: 1.3rem;
  padding: 0 0.5rem;
  margin-top: 0.1rem;
}
.texts_zone_content_cards_header .options .stroke_section .stroke_color {
  width: 100%;
  padding: 0 0.5rem;
  margin: 0.1rem 0;
}
.texts_zone_content_cards_header .options .stroke_section .stroke_color input {
  width: 100%;
  border-radius: 0.3rem;
  background-color: #ffffff;
}
.texts_zone_content_cards_header .options .stroke_section .stroke_color span {
  font-size: 0.8rem;
  color: #d2d0d0;
}
.texts_zone_content_cards_header .options .stroke_section .stroke_color .sub_block {
  width: 100%;
  margin: 0.2rem 0;
}
.texts_zone_content_cards_header .options .stroke_section .stroke_color .sub_block input[type=range] {
  width: 100%;
  height: 6px;
  margin: 0.4rem 0;
  background: #ffffff;
  border-radius: 5px;
  outline: none;
  appearance: none;
}
.texts_zone_content_cards_header .options .stroke_section .stroke_color .sub_block input[type=range]::-webkit-slider-thumb {
  appearance: none;
  width: 6px;
  height: 20px;
  background: #898989;
  border-radius: 1rem;
  cursor: pointer;
}
.texts_zone_content_cards_header .options .stroke_section .stroke_color .sub_block span {
  display: block;
  font-size: 0.8rem;
  color: #d2d0d0;
}
.texts_zone_content_cards_header .options .stroke_section .stroke_blur {
  width: 100%;
  padding: 0 0.5rem;
  color: #ffffff;
}
.texts_zone_content_cards_header .options .stroke_section .stroke_blur input {
  width: 30%;
  border-radius: 0;
  background-color: #dddddd;
}
.texts_zone_content_cards_header .options .stroke_section .stroke_opacity {
  width: 100%;
  padding: 0 0.5rem;
  margin: 0.2rem 0;
}
.texts_zone_content_cards_header .options .stroke_section .stroke_opacity input[type=range] {
  width: 100%;
  height: 6px;
  margin: 0.4rem 0;
  background: #ffffff;
  border-radius: 5px;
  outline: none;
  appearance: none;
}
.texts_zone_content_cards_header .options .stroke_section .stroke_opacity input[type=range]::-webkit-slider-thumb {
  appearance: none;
  width: 6px;
  height: 20px;
  background: #898989;
  border-radius: 1rem;
  cursor: pointer;
}
.texts_zone_content_cards_header .options .stroke_section .stroke_opacity span {
  display: block;
  font-size: 0.8rem;
  color: #d2d0d0;
}
.texts_zone_content_cards_header .options .stroke_section .stroke_btn {
  width: 100%;
  padding: 0 0.5rem;
  margin-top: 0.3rem;
  text-align: center;
}
.texts_zone_content_cards_header .options .stroke_section .stroke_btn button {
  width: 50%;
  padding: 0.2rem 0.1rem;
  font-size: 0.8rem;
  background: linear-gradient(180deg, #D91D6F 0%, #92124A 100%);
  border: 1px solid transparent;
  color: #FFFFFF;
  outline: none;
  border-radius: 0.3rem;
  cursor: pointer;
  transition: 0.2s linear;
}
.texts_zone_content_cards_header .options .stroke_section .stroke_btn button:hover {
  background: linear-gradient(180deg, #D91D6F 50%, #92124A 100%);
  border: 1px solid #FFFFFF;
}
.texts_zone_content_cards_body {
  padding: 0.3rem 0;
}
.texts_zone_content_cards_body .text_O {
  font-size: 0.8rem;
  color: #FFFFFF;
  margin: 0.5rem 0;
}
.texts_zone_content_cards_body .text_T {
  font-size: 1rem;
  color: #FFFFFF;
  margin: 0.5rem 0;
  background-color: #2E2632;
  width: 100%;
  padding: 0.3rem 0.5rem;
  outline: none;
  resize: vertical;
}
.texts_zone_content_cards_body .validation_block {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.texts_zone_content_cards_body .validation_block .validated_by {
  font-size: 0.6rem;
  font-weight: 600;
  color: #a7a4a4;
}
.texts_zone_content_cards_body .validation_block .validated_at {
  color: #a7a4a4;
  font-size: 0.55rem;
  font-weight: 500;
}
.texts_zone_content_cards_body .validated_text {
  color: rgb(5, 182, 5);
}
.texts_zone_content_cards_body .btns {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
}
.texts_zone_content_cards_body .btns .valid,
.texts_zone_content_cards_body .btns .comment {
  display: flex;
  color: #FFFFFF;
  cursor: pointer;
}
.texts_zone_content_cards_body .btns .commentActive {
  color: orangered;
}
.texts_zone_content_cards_body .btns .validated {
  color: rgb(6, 185, 6);
}
.texts_zone_content_cards_body .btns .validating {
  display: flex;
  color: #FFFFFF;
  animation: sending 0.5s linear infinite;
}
.texts_zone_content_cards_body .add_comment {
  width: 100%;
  display: flex;
  padding: 0.2rem 0;
}
.texts_zone_content_cards_body .add_comment textarea {
  width: 85%;
  height: 3rem;
  resize: none;
  border: none;
  outline: none;
  color: #FFFFFF;
  padding: 0.5rem 0.2rem;
  border-top: 2px solid #463B4D;
  background-color: #2E2632;
}
.texts_zone_content_cards_body .add_comment .send_comment {
  width: 15%;
  height: 3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5rem;
  color: #FFFFFF;
  cursor: pointer;
  transition: 0.2s linear;
}
.texts_zone_content_cards_body .add_comment .send_comment:hover {
  color: orange;
}
.texts_zone_content_cards_body .add_comment .send_loading {
  animation: sending 0.5s linear infinite;
}
.texts_zone_content_cards_body .add_comment .dis-none {
  display: none;
}
.texts_zone_content_cards_body .comments_exist {
  padding: 0.5rem 0.2rem;
  border-top: 1px solid #463B4D;
  border-bottom: 1px solid #463B4D;
}
.texts_zone_content_cards_body .comments_exist .comments_exist_header {
  width: 100%;
  display: flex;
}
.texts_zone_content_cards_body .comments_exist .comments_exist_header .group {
  width: 50%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0.5rem;
}
.texts_zone_content_cards_body .comments_exist .comments_exist_header .group .small_avatar {
  width: 1.8rem;
  height: 1.8rem;
  background-color: #aeadad;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  font-size: 1rem;
  font-weight: 600;
}
.texts_zone_content_cards_body .comments_exist .comments_exist_header .group .small_username {
  color: #FFFFFF;
}
.texts_zone_content_cards_body .comments_exist .comments_exist_header .comment_date {
  width: 50%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  color: #a7a4a4;
  font-size: 0.55rem;
  font-weight: 500;
}
.texts_zone_content_cards_body .comments_exist .comments_exist_body {
  width: 100%;
  padding: 0.5rem 0;
  color: #FFFFFF;
  font-size: 0.8rem;
}
.texts_zone_content_cards_body .comments_exist .comments_exist_btns {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
}
.texts_zone_content_cards_body .comments_exist .comments_exist_btns span {
  font-size: 1rem;
  color: #FFFFFF;
  cursor: pointer;
}
.texts_zone_content_cards_body .comments_exist .comments_exist_btns .deleting {
  display: flex;
  animation: sending 0.5s linear infinite;
}
.texts_zone_content_cards .d-none {
  display: none;
}

.zoneLoading {
  width: 100%;
  height: calc(100vh - 93.19px - 70.59px);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
}
.zoneLoading img {
  width: 30%;
}
.zoneLoading h3 {
  font-size: 1rem;
  font-weight: 700;
  color: #979797;
}

@keyframes sending {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/text_zone/_TextZone.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,sBAAA;EACA,UAAA;EACA,mBAAA;EACA,qBAAA;EACA,YAAA;AACJ;AACI;EACI,WAAA;EACA,aAAA;EACA,mBAAA;AACR;AAEQ;EACI,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,UAAA;AAAZ;AAGQ;EACI,UAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;AADZ;AAIY;;EAEI,UAAA;EACA,cAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;AAFhB;AAKY;EACI,UAAA;AAHhB;AAMY;EACI,aAAA;EACA,cAAA;EACA,kBAAA;AAJhB;AAOY;EACI,gBAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,MAAA;AALhB;AASY;EACI,kBAAA;EACA,eAAA;EACA,OAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EAEA,oBAAA;AARhB;AAWY;EACI,YAAA;EACA,aAAA;EACA,yBAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;AAThB;AAWgB;EACI,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AATpB;AAagB;EACI,WAAA;EACA,iBAAA;EACA,gBAAA;AAXpB;AAcoB;EACI,WAAA;EAEA,qBAAA;EACA,yBAAA;AAbxB;AAgBoB;EACI,iBAAA;EACA,cAAA;AAdxB;AAiBoB;EACI,WAAA;EACA,gBAAA;AAfxB;AAkBwB;EACI,WAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EAEA,gBAAA;AAhB5B;AAkB4B;EAEI,gBAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;AAhBhC;AAoBwB;EACI,cAAA;EACA,iBAAA;EACA,cAAA;AAlB5B;AAuBgB;EACI,WAAA;EACA,iBAAA;EACA,cAAA;AArBpB;AAwBoB;EACI,UAAA;EACA,gBAAA;EACA,yBAAA;AAtBxB;AA0BgB;EACI,WAAA;EACA,iBAAA;EACA,gBAAA;AAxBpB;AA2BoB;EACI,WAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EAEA,gBAAA;AAzBxB;AA2BwB;EAEI,gBAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;AAzB5B;AA6BoB;EACI,cAAA;EACA,iBAAA;EACA,cAAA;AA3BxB;AA+BgB;EACI,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AA7BpB;AA+BoB;EACI,UAAA;EACA,sBAAA;EACA,iBAAA;EACA,6DAAA;EACA,6BAAA;EACA,cAAA;EACA,aAAA;EACA,qBAAA;EACA,eAAA;EACA,uBAAA;AA7BxB;AA+BwB;EACI,8DAAA;EACA,yBAAA;AA7B5B;AAsCI;EACI,iBAAA;AApCR;AAsCQ;EACI,iBAAA;EACA,cAAA;EACA,gBAAA;AApCZ;AAuCQ;EACI,eAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,WAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;AArCZ;AAwCQ;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AAtCZ;AAwCY;EACI,iBAAA;EACA,gBAAA;EACA,cAAA;AAtChB;AAyCY;EACI,cAAA;EACA,kBAAA;EACA,gBAAA;AAvChB;AA4CQ;EACI,qBAAA;AA1CZ;AA6CQ;EACI,WAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;AA3CZ;AA6CY;;EAEI,aAAA;EACA,cAAA;EACA,eAAA;AA3ChB;AA8CY;EACI,gBAAA;AA5ChB;AA+CY;EACI,qBAAA;AA7ChB;AAgDY;EACI,aAAA;EACA,cAAA;EACA,uCAAA;AA9ChB;AAkDQ;EACI,WAAA;EACA,aAAA;EACA,iBAAA;AAhDZ;AAkDY;EACI,UAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,sBAAA;EACA,6BAAA;EACA,yBAAA;AAhDhB;AAmDY;EACI,UAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,uBAAA;AAjDhB;AAmDgB;EACI,aAAA;AAjDpB;AAqDY;EACI,uCAAA;AAnDhB;AAsDY;EACI,aAAA;AApDhB;AAwDQ;EACI,sBAAA;EACA,6BAAA;EACA,gCAAA;AAtDZ;AAwDY;EACI,WAAA;EACA,aAAA;AAtDhB;AAwDgB;EACI,UAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,WAAA;AAtDpB;AAwDoB;EACI,aAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;AAtDxB;AAyDoB;EACI,cAAA;AAvDxB;AA2DgB;EACI,UAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAzDpB;AA6DY;EACI,WAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;AA3DhB;AA8DY;EACI,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;AA5DhB;AA8DgB;EACI,eAAA;EACA,cAAA;EACA,eAAA;AA5DpB;AA+DgB;EAEI,aAAA;EACA,uCAAA;AA9DpB;AAoEI;EACI,aAAA;AAlER;;AAsEA;EACI,WAAA;EACA,uCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;AAnEJ;AAqEI;EACI,UAAA;AAnER;AAsEI;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AApER;;AAwEA;EACI;IACI,uBAAA;EArEN;EAwEE;IACI,yBAAA;EAtEN;AACF","sourcesContent":[".texts_zone_content_cards {\n    background-color: #2E2632;\n    padding: .5rem .6rem;\n    width: 90%;\n    margin: .5rem auto;\n    border-radius: .8rem;\n    border: none;\n\n    &_header {\n        width: 100%;\n        display: flex;\n        align-items: center;\n        // border: 1px solid red;\n\n        .ref {\n            font-size: .8rem;\n            font-weight: 600;\n            color: #898989;\n            width: 20%;\n        }\n\n        .options {\n            width: 80%;\n            display: flex;\n            justify-content: flex-end;\n            align-items: center;\n            gap: .5rem;\n            position: relative;\n            // border: 1px solid red;\n\n            select,\n            input {\n                width: 23%;\n                height: 1.2rem;\n                font-size: .7rem;\n                border-radius: .8rem;\n                text-align: center;\n                outline: none;\n                border: none;\n            }\n\n            input[type=\"number\"] {\n                width: 16%;\n            }\n\n            #color {\n                width: 1.2rem;\n                height: 1.2rem;\n                border-radius: 50%;\n            }\n\n            .fontStyle {\n                color: orangered;\n                width: 1.2rem;\n                height: 1.2rem;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                border-radius: 50%;\n                cursor: pointer;\n                font-weight: 600;\n                color: #898989;\n                background-color: #1C1620;\n                position: relative;\n                top: 0;\n                // border: 1px solid red;\n            }\n\n            .hidden-color-input {\n                position: absolute;\n                bottom: -.5rem;\n                left: 0;\n                opacity: 0;\n                width: 0;\n                height: 0;\n                // display: none;\n                pointer-events: none;\n            }\n\n            .stroke_section {\n                width: 10rem;\n                height: 14rem;\n                background-color: #1C1620;\n                border: 1px solid #d2d0d0;\n                border-radius: .3rem;\n                position: absolute;\n                left: -3rem;\n                bottom: -14.1rem;\n                z-index: 1000;\n\n                .show_hide_stroke {\n                    width: 100%;\n                    font-size: 1.3rem;\n                    padding: 0 .5rem;\n                    margin-top: .1rem;\n                    // border: 1px solid red;\n                }\n\n                .stroke_color {\n                    width: 100%;\n                    padding: 0 .5rem;\n                    margin: .1rem 0;\n                    // border: 1px solid red;\n\n                    input {\n                        width: 100%;\n                        // height: 1.6rem;\n                        border-radius: .3rem;\n                        background-color: #ffffff;\n                    }\n\n                    span{\n                        font-size: .8rem;\n                        color: #d2d0d0;\n                    }\n\n                    .sub_block{\n                        width: 100%;\n                        margin: .2rem 0;\n                        // border: 1px solid red;\n    \n                        input[type=\"range\"] {\n                            width: 100%;\n                            height: 6px;\n                            margin: .4rem 0;\n                            background: #ffffff;\n                            border-radius: 5px;\n                            outline: none;\n                            -webkit-appearance: none;\n                            appearance: none;\n    \n                            &::-webkit-slider-thumb {\n                                -webkit-appearance: none;\n                                appearance: none;\n                                width: 6px;\n                                height: 20px;\n                                background: #898989;\n                                border-radius: 1rem;\n                                cursor: pointer;\n                              }\n                        }\n\n                        span{\n                            display: block;\n                            font-size: .8rem;\n                            color: #d2d0d0;\n                        }\n                    }\n                }\n\n                .stroke_blur {\n                    width: 100%;\n                    padding: 0 .5rem;\n                    color: #ffffff;\n                    // border: 1px solid red;\n\n                    input {\n                        width: 30%;\n                        border-radius: 0;\n                        background-color: #dddddd;\n                    }\n                }\n\n                .stroke_opacity {\n                    width: 100%;\n                    padding: 0 .5rem;\n                    margin: .2rem 0;\n                    // border: 1px solid red;\n\n                    input[type=\"range\"] {\n                        width: 100%;\n                        height: 6px;\n                        margin: .4rem 0;\n                        background: #ffffff;\n                        border-radius: 5px;\n                        outline: none;\n                        -webkit-appearance: none;\n                        appearance: none;\n\n                        &::-webkit-slider-thumb {\n                            -webkit-appearance: none;\n                            appearance: none;\n                            width: 6px;\n                            height: 20px;\n                            background: #898989;\n                            border-radius: 1rem;\n                            cursor: pointer;\n                          }\n                    }\n\n                    span{\n                        display: block;\n                        font-size: .8rem;\n                        color: #d2d0d0;\n                    }\n                }\n\n                .stroke_btn {\n                    width: 100%;\n                    padding: 0 .5rem;\n                    margin-top: .3rem;\n                    text-align: center;\n\n                    button {\n                        width: 50%;\n                        padding: .2rem .1rem;\n                        font-size: .8rem;\n                        background: linear-gradient(180deg, #D91D6F 0%, #92124A 100%);\n                        border: 1px solid transparent;\n                        color: #FFFFFF;\n                        outline: none;\n                        border-radius: .3rem;\n                        cursor: pointer;\n                        transition: .2s linear;\n\n                        &:hover {\n                            background: linear-gradient(180deg, #D91D6F 50%, #92124A 100%);\n                            border: 1px solid #FFFFFF;\n                        }\n                    }\n                }\n            }\n\n        }\n    }\n\n    &_body {\n        padding: .3rem 0;\n\n        .text_O {\n            font-size: .8rem;\n            color: #FFFFFF;\n            margin: .5rem 0;\n        }\n\n        .text_T {\n            font-size: 1rem;\n            color: #FFFFFF;\n            margin: .5rem 0;\n            background-color: #2E2632;\n            width: 100%;\n            padding: .3rem .5rem;\n            outline: none;\n            resize: vertical;\n        }\n\n        .validation_block {\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n\n            .validated_by {\n                font-size: .6rem;\n                font-weight: 600;\n                color: #a7a4a4;\n            }\n\n            .validated_at {\n                color: #a7a4a4;\n                font-size: .55rem;\n                font-weight: 500;\n            }\n        }\n\n\n        .validated_text {\n            color: rgb(5, 182, 5);\n        }\n\n        .btns {\n            width: 100%;\n            display: flex;\n            justify-content: flex-end;\n            align-items: center;\n            gap: 1rem;\n\n            .valid,\n            .comment {\n                display: flex;\n                color: #FFFFFF;\n                cursor: pointer;\n            }\n\n            .commentActive {\n                color: orangered;\n            }\n\n            .validated {\n                color: rgb(6, 185, 6);\n            }\n\n            .validating {\n                display: flex;\n                color: #FFFFFF;\n                animation: sending .5s linear infinite;\n            }\n        }\n\n        .add_comment {\n            width: 100%;\n            display: flex;\n            padding: .2rem 0;\n\n            textarea {\n                width: 85%;\n                height: 3rem;\n                resize: none;\n                border: none;\n                outline: none;\n                color: #FFFFFF;\n                padding: .5rem .2rem;\n                border-top: 2px solid #463B4D;\n                background-color: #2E2632;\n            }\n\n            .send_comment {\n                width: 15%;\n                height: 3rem;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                font-size: 1.5rem;\n                color: #FFFFFF;\n                cursor: pointer;\n                transition: .2s linear;\n\n                &:hover {\n                    color: orange;\n                }\n            }\n\n            .send_loading {\n                animation: sending .5s linear infinite;\n            }\n\n            .dis-none {\n                display: none;\n            }\n        }\n\n        .comments_exist {\n            padding: .5rem .2rem;\n            border-top: 1px solid #463B4D;\n            border-bottom: 1px solid #463B4D;\n\n            .comments_exist_header {\n                width: 100%;\n                display: flex;\n\n                .group {\n                    width: 50%;\n                    display: flex;\n                    justify-content: flex-start;\n                    align-items: center;\n                    gap: .5rem;\n\n                    .small_avatar {\n                        width: 1.8rem;\n                        height: 1.8rem;\n                        background-color: #aeadad;\n                        border-radius: 50%;\n                        display: flex;\n                        justify-content: center;\n                        align-items: center;\n                        text-transform: uppercase;\n                        font-size: 1rem;\n                        font-weight: 600;\n                    }\n\n                    .small_username {\n                        color: #FFFFFF;\n                    }\n                }\n\n                .comment_date {\n                    width: 50%;\n                    display: flex;\n                    justify-content: flex-end;\n                    align-items: center;\n                    color: #a7a4a4;\n                    font-size: .55rem;\n                    font-weight: 500;\n                }\n            }\n\n            .comments_exist_body {\n                width: 100%;\n                padding: .5rem 0;\n                color: #FFFFFF;\n                font-size: .8rem;\n            }\n\n            .comments_exist_btns {\n                display: flex;\n                justify-content: flex-end;\n                align-items: center;\n                gap: 1rem;\n\n                span {\n                    font-size: 1rem;\n                    color: #FFFFFF;\n                    cursor: pointer;\n                }\n\n                .deleting {\n                    // border: 1px solid red;\n                    display: flex;\n                    animation: sending .5s linear infinite;\n                }\n            }\n        }\n    }\n\n    .d-none {\n        display: none;\n    }\n}\n\n.zoneLoading {\n    width: 100%;\n    height: calc((100vh - 93.19px) - 70.59px);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    position: relative;\n\n    img {\n        width: 30%;\n    }\n\n    h3 {\n        font-size: 1rem;\n        font-weight: 700;\n        color: #979797;\n    }\n}\n\n@keyframes sending {\n    from {\n        transform: rotate(0deg);\n    }\n\n    to {\n        transform: rotate(360deg);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
